import { connect } from "react-redux";
import { ThunkDispatch } from "@reduxjs/toolkit";

import { ApplicationState } from "../../redux/ApplicationState";
import LeftNavbar from "../components/LeftNavbar";
import { resetStates } from "../../actions/Common";
import { getMasterServiceProvider, getMasterServiceProviderDefault } from "../../actions/Master";
import { getSsoHppUrl, getSsoHpsUrl } from "../../actions/UserAction";
import { SsoHpsUrlPayload } from "../../models/User";

const mapStateToProps = ({masterFeatureAccessState, ssoHppClaimsStatusUrlState, appConfigsState, loggedInUserState, masterServiceProviderDefaultState, referralListState, referralSearchState, ssoHpsClaimsStatusUrlState }: ApplicationState) => ({
  config: appConfigsState.response,
  loggedInUser: loggedInUserState.response,
  masterServiceProviderList: masterServiceProviderDefaultState.response,
  masterServiceProviderErrorList: masterServiceProviderDefaultState.error,
  masterFeatureAccessState: masterFeatureAccessState.response,
  referralList: referralListState.response,
  referralSearchList: referralSearchState.response,
  ssoHpsClaimsStatusUrlState: ssoHpsClaimsStatusUrlState.response,
  ssoHppClaimsStatusUrlState: ssoHppClaimsStatusUrlState.response,
});

const mapDispatchToProps = (
  dispatch: ThunkDispatch<ApplicationState, Record<string, never>, any>
) => {
  return {
    resetStates: (actionType: string) => {
      dispatch(resetStates(actionType));
    },
    getMasterServiceProvider: () => {
      dispatch(getMasterServiceProvider());
    },
    getMasterServiceProviderDefault: () => {
      dispatch(getMasterServiceProviderDefault());
    },
    getSsoHpsUrl: (payload: SsoHpsUrlPayload) => {
      dispatch(getSsoHpsUrl(payload));
    },
    getSsoHppUrl: () => {
      dispatch(getSsoHppUrl());
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(LeftNavbar);